var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAaPolicyRounded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#F2F4F7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 48,
    height: 48,
    rx: 24,
    stroke: "#F9FAFB",
    strokeWidth: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 20C32.93 20 33.395 20 33.7765 20.1022C34.8117 20.3796 35.6204 21.1883 35.8978 22.2235C36 22.605 36 23.07 36 24V33.2C36 34.8802 36 35.7202 35.673 36.362C35.3854 36.9265 34.9265 37.3854 34.362 37.673C33.7202 38 32.8802 38 31.2 38H24.8C23.1198 38 22.2798 38 21.638 37.673C21.0735 37.3854 20.6146 36.9265 20.327 36.362C20 35.7202 20 34.8802 20 33.2V24C20 23.07 20 22.605 20.1022 22.2235C20.3796 21.1883 21.1883 20.3796 22.2235 20.1022C22.605 20 23.07 20 24 20M25 31L27 33L31.5 28.5M25.6 22H30.4C30.9601 22 31.2401 22 31.454 21.891C31.6422 21.7951 31.7951 21.6422 31.891 21.454C32 21.2401 32 20.9601 32 20.4V19.6C32 19.0399 32 18.7599 31.891 18.546C31.7951 18.3578 31.6422 18.2049 31.454 18.109C31.2401 18 30.9601 18 30.4 18H25.6C25.0399 18 24.7599 18 24.546 18.109C24.3578 18.2049 24.2049 18.3578 24.109 18.546C24 18.7599 24 19.0399 24 19.6V20.4C24 20.9601 24 21.2401 24.109 21.454C24.2049 21.6422 24.3578 21.7951 24.546 21.891C24.7599 22 25.0399 22 25.6 22Z",
    stroke: "#0860C4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAaPolicyRounded);
export default __webpack_public_path__ + "static/media/aa-policy-rounded.5d467b3ec5724b836d1daa4b41685f93.svg";
export { ForwardRef as ReactComponent };